import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class AlvikDrive extends ASTBlock {
    constructor(color) {
        super(color, "alvik_drive")
        this.predefinedInputs = {
            "linear_speed": {
                "block": {
                    "type": "number",
                    "fields": {
                        "value": 0
                    }
                }
            },
            "angular_speed": {
                "block": {
                    "type": "number",
                    "fields": {
                        "value": 0
                    }
                }
            }
        }
        this.TOP_LEVEL = undefined
    }

    addToBlockly() {
        var json = {
            "tooltip": "",
            "helpUrl": "",
            "message0": "fahr %1 mit %2 cm/s und fahr nach %3 %4 mit %5 Grad/s %6",
            "args0": [{
                    "type": "field_dropdown",
                    "name": "linear_direction",
                    "options": [
                        [
                            "vorwärts",
                            "+"
                        ],
                        [
                            "rückwärts",
                            "-"
                        ]
                    ]
                },
                {
                    "type": "input_value",
                    "name": "linear_speed",
                    "check": "Number"
                },
                {
                    "type": "input_dummy",
                    "name": "NAME"
                },
                {
                    "type": "field_dropdown",
                    "name": "angular_direction",
                    "options": [
                        [
                            "links",
                            "+"
                        ],
                        [
                            "rechts",
                            "-"
                        ]
                    ]
                },
                {
                    "type": "input_value",
                    "name": "angular_speed",
                    "check": "Number"
                },
                {
                    "type": "input_dummy",
                    "name": "NAME2"
                }
            ],
            "previousStatement": null,
            "nextStatement": null
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}